const enums = {
    rentalStatus: ['Rented', 'Vacant'],
    availabilityStatus: ['Available', 'Unavailable', 'Unavailable_On_Move_Out'],
    categories: ['No_Category', 'Climate_Controlled', 'Outdoor_Parking', 'Mobile', 'Automobile'],
};

export default enums;
